"use client"

// Shared helper for "have I seen this already" popup/modal state. Backed by
// the user_seen_unlocks table via /api/seen-unlocks for logged-in accounts,
// so it follows the user across browsers/devices instead of resetting every
// time they log in somewhere new. Logged-out visitors have no account row to
// persist to, so callers should fall back to localStorage for that case
// (there's no account-scoped alternative before the user has one).

export async function fetchSeenState(): Promise<{ keys: Set<string>; seenAt: Record<string, string> }> {
  try {
    const res = await fetch("/api/seen-unlocks")
    if (!res.ok) return { keys: new Set(), seenAt: {} }
    const { keys, seenAt } = (await res.json()) as { keys: string[]; seenAt: Record<string, string> }
    return { keys: new Set(keys ?? []), seenAt: seenAt ?? {} }
  } catch {
    return { keys: new Set(), seenAt: {} }
  }
}

export async function markSeen(key: string): Promise<void> {
  try {
    // keepalive lets this survive a navigation/refresh that happens right
    // after the caller closes a modal -- callers (e.g. FounderPromoModal's
    // dismiss()) fire this without awaiting it, so a quick refresh right
    // after dismissing could otherwise cancel the request mid-flight before
    // the server ever recorded the dismissal, making the modal reappear on
    // every reload despite having been closed every time.
    await fetch("/api/seen-unlocks", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ keys: [key] }),
      keepalive: true,
    })
  } catch {}
}
